<template>
  <div
    class="
      flex
      justify-center
      items-center
      leading-none
      bg-indigo-500
      rounded-full
      cursor-pointer
      text-indigo-1000 text-shadow
    "
    :class="{ 
      'w-20 h-20 text-4xl': size === 'md', 
      'w-10 h-10 text-lg': size === 'sm', 
      'w-8 h-8 text-base': size === 'xs' 
    }"
    @click="eventBus.$emit('auth:showPremiumModal', 'premium icon')"
  >
    <i class="fas fa-lock-alt" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import eventBus from "@/utils/event-bus";

export default defineComponent({
  props: {
    size: {
      default: "md",
      type: String,
    },
  },

  setup() {
    return {
      eventBus,
    }
  }
});
</script>

<style>
</style>